// src/design-system/components/DashboardCard.jsx
import React from 'react';

/**
 * DashboardCard — Card de métrica/stat com glassmorphism.
 *
 * @param {node}   icon    - Ícone do card
 * @param {string} label   - Label da métrica
 * @param {string|number} value - Valor principal
 * @param {string} trend   - Texto de tendência (ex: "+12%")
 * @param {'up'|'down'} trendDir - Direção da tendência
 */
export default function DashboardCard({
  icon,
  label,
  value,
  trend,
  trendDir = 'up',
  className = '',
  children,
  style,
}) {
  return (
    <article className={`ds-dashboard-card ${className}`} style={style}>
      {icon && <div className="ds-dashboard-card__icon">{icon}</div>}
      {label && <span className="ds-dashboard-card__label">{label}</span>}
      {value !== undefined && <span className="ds-dashboard-card__value">{value}</span>}
      {trend && (
        <span className={`ds-dashboard-card__trend ds-dashboard-card__trend--${trendDir}`}>
          {trendDir === 'up' ? '↑' : '↓'} {trend}
        </span>
      )}
      {children}
    </article>
  );
}
